import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, RichText, InspectorControls } from '@wordpress/block-editor';
import { PanelBody } from '@wordpress/components';

registerBlockType('puroclean/trust-factors', {
    edit({ attributes, setAttributes }) {
        const blockProps = useBlockProps({
            className: 'trust-factors'
        });

        // Provide fallbacks for all attributes
        const {
            heading = 'Why Customers Trust PuroClean for Property Restoration',
            mobileHeading = 'Why Choose PuroClean',
            factor1Title = '20+ YEARS',
            factor1Description = 'Of Trusted Industry<br/>Experience In Property<br/>Restoration',
            factor2Title = '100% CERTIFIED',
            factor2Description = 'Professionals Who Are<br/>Screened, Insured, And<br/>Trained',
            factor3Title = '400+ LOCATIONS',
            factor3Description = 'Across The U.S., Serving<br/>Communities Nationwide.',
            factor4Title = '24/7 RESPONSE',
            factor4Description = 'With Advanced Tools And<br/>Cutting-Edge Restoration<br/>Technology.',
            align = 'full'
        } = attributes || {};

        return (
            <div {...blockProps}>
                <InspectorControls>
                    <PanelBody title="Mobile Heading" initialOpen={true}>
                        <RichText
                            tagName="div"
                            className="wp-block-paragraph"
                            value={mobileHeading}
                            onChange={(value) => setAttributes({ mobileHeading: value })}
                            placeholder="Enter mobile heading (optional)..."
                            allowedFormats={['core/bold', 'core/italic']}
                            keepPlaceholderOnFocus={true}
                        />
                    </PanelBody>
                </InspectorControls>
                {/* Main Trust Factors Section */}
                <div className={`py-12 align${align} max-w-none bg-red-700 text-white`}>
                    <div className="max-w-content mx-auto">
                        <RichText
                            tagName="h2"
                            className="text-center text-4xl font-bold mb-12 text-white"
                            value={heading}
                            onChange={(value) => setAttributes({ heading: value })}
                            placeholder="Enter main heading..."
                            allowedFormats={['core/bold', 'core/italic']}
                        />
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
                            {/* Trust Factor 1 - 20+ Years */}
                            <div>
                                <RichText
                                    tagName="h3"
                                    className="text-4xl font-bold mb-4 text-white leading-tight"
                                    value={factor1Title}
                                    onChange={(value) => setAttributes({ factor1Title: value })}
                                    placeholder="Enter title..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                                <RichText
                                    tagName="p"
                                    className="text-white text-base leading-relaxed"
                                    value={factor1Description}
                                    onChange={(value) => setAttributes({ factor1Description: value })}
                                    placeholder="Enter description..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                            </div>
                            
                            {/* Trust Factor 2 - 100% Certified */}
                            <div>
                                <RichText
                                    tagName="h3"
                                    className="text-4xl font-bold mb-4 text-white leading-tight"
                                    value={factor2Title}
                                    onChange={(value) => setAttributes({ factor2Title: value })}
                                    placeholder="Enter title..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                                <RichText
                                    tagName="p"
                                    className="text-white text-base leading-relaxed"
                                    value={factor2Description}
                                    onChange={(value) => setAttributes({ factor2Description: value })}
                                    placeholder="Enter description..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                            </div>
                            
                            {/* Trust Factor 3 - 400+ Locations */}
                            <div>
                                <RichText
                                    tagName="h3"
                                    className="text-4xl font-bold mb-4 text-white leading-tight"
                                    value={factor3Title}
                                    onChange={(value) => setAttributes({ factor3Title: value })}
                                    placeholder="Enter title..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                                <RichText
                                    tagName="p"
                                    className="text-white text-base leading-relaxed"
                                    value={factor3Description}
                                    onChange={(value) => setAttributes({ factor3Description: value })}
                                    placeholder="Enter description..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                            </div>
                            
                            {/* Trust Factor 4 - 24/7 Response */}
                            <div>
                                <RichText
                                    tagName="h3"
                                    className="text-4xl font-bold mb-4 text-white leading-tight"
                                    value={factor4Title}
                                    onChange={(value) => setAttributes({ factor4Title: value })}
                                    placeholder="Enter title..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                                <RichText
                                    tagName="p"
                                    className="text-white text-base leading-relaxed"
                                    value={factor4Description}
                                    onChange={(value) => setAttributes({ factor4Description: value })}
                                    placeholder="Enter description..."
                                    allowedFormats={['core/bold', 'core/italic']}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Color Bar */}
                <div className="flex w-full h-4">
                    <div className="flex-1 bg-secondary"></div>
                    <div className="flex-1 bg-primary"></div>
                    <div className="flex-1 bg-[#373536]"></div>
                    <div className="flex-1 bg-[#A7A9AC]"></div>
                </div>
            </div>
        );
    },
    save() {
        return null; // Server-side rendered
    }
}); 